/**
 * @generated SignedSource<<827ccaea9b572077674d2ecfb503f9cd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "tournamentId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "databaseId",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "dateOfBirth",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "gender",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "nationality",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "concreteType": "Organisation",
  "kind": "LinkedField",
  "name": "organisations",
  "plural": true,
  "selections": [
    (v9/*: any*/),
    (v2/*: any*/)
  ],
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasMandatoryPhone",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasRoundReservations",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "category",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "phone",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "TournamentPlayersQuery",
    "selections": [
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "TournamentUserList_query"
      },
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Tournament",
        "kind": "LinkedField",
        "name": "tournament",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "TournamentPlayerList_tournament"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "TournamentPlayersQuery",
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Literal",
            "name": "limit",
            "value": 10
          },
          {
            "kind": "Literal",
            "name": "page",
            "value": 1
          },
          {
            "kind": "Literal",
            "name": "sortBy",
            "value": "first_name"
          },
          {
            "kind": "Literal",
            "name": "sortDirection",
            "value": "asc"
          },
          {
            "kind": "Variable",
            "name": "tournamentId",
            "variableName": "tournamentId"
          }
        ],
        "concreteType": "UserPagination",
        "kind": "LinkedField",
        "name": "userPagination",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "users",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Player",
                "kind": "LinkedField",
                "name": "player",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/),
                  (v9/*: any*/),
                  (v10/*: any*/),
                  (v2/*: any*/)
                ],
                "storageKey": null
              },
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalCount",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Tournament",
        "kind": "LinkedField",
        "name": "tournament",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v11/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hasPairs",
            "storageKey": null
          },
          (v12/*: any*/),
          (v9/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "TournamentPlayer",
            "kind": "LinkedField",
            "name": "tournamentPlayers",
            "plural": true,
            "selections": [
              (v13/*: any*/),
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasScores",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasPaid",
                "storageKey": null
              },
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "rounds",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "status",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "tournamentId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Player",
                "kind": "LinkedField",
                "name": "player",
                "plural": false,
                "selections": [
                  (v13/*: any*/),
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v8/*: any*/),
                  (v7/*: any*/),
                  (v9/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "userId",
                    "storageKey": null
                  },
                  (v10/*: any*/),
                  (v2/*: any*/),
                  (v14/*: any*/),
                  (v15/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "user",
                    "plural": false,
                    "selections": [
                      (v14/*: any*/),
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Tournament",
                "kind": "LinkedField",
                "name": "tournament",
                "plural": false,
                "selections": [
                  (v12/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TournamentRound",
                    "kind": "LinkedField",
                    "name": "tournamentRounds",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "round",
                        "storageKey": null
                      },
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasBuffet",
                    "storageKey": null
                  },
                  (v11/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "buffetChoice",
                "storageKey": null
              },
              (v7/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ReservationLine",
            "kind": "LinkedField",
            "name": "unconfirmedReservationLines",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              (v5/*: any*/),
              (v8/*: any*/),
              (v14/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "mainEmail",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "mainPhone",
                "storageKey": null
              },
              (v15/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Organisation",
            "kind": "LinkedField",
            "name": "organisation",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "defaultCountryCode",
                "storageKey": null
              },
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "6f9b14b9b3b7c7c67eef2d7dfec799bc",
    "id": null,
    "metadata": {},
    "name": "TournamentPlayersQuery",
    "operationKind": "query",
    "text": "query TournamentPlayersQuery(\n  $id: ID!\n  $tournamentId: Int\n) {\n  ...TournamentUserList_query\n  tournament(id: $id) {\n    id\n    ...TournamentPlayerList_tournament\n  }\n}\n\nfragment NewTournamentPlayerModal_tournament on Tournament {\n  id\n  organisation {\n    defaultCountryCode\n    id\n  }\n}\n\nfragment TournamentPlayerList_tournament on Tournament {\n  hasMandatoryPhone\n  hasPairs\n  hasRoundReservations\n  name\n  tournamentPlayers {\n    ...TournamentPlayer_tournamentPlayer\n    id\n    player {\n      email\n      id\n    }\n  }\n  unconfirmedReservationLines {\n    databaseId\n    firstName\n    lastName\n    email\n    mainEmail\n    mainPhone\n    phone\n    id\n  }\n  ...NewTournamentPlayerModal_tournament\n  id\n}\n\nfragment TournamentPlayerModal_tournamentPlayer on TournamentPlayer {\n  buffetChoice\n  category\n  id\n  nationality\n  tournamentId\n  player {\n    databaseId\n    firstName\n    lastName\n    email\n    name\n    nationality\n    phone\n    userId\n    user {\n      email\n      id\n    }\n    id\n  }\n  tournament {\n    hasBuffet\n    hasMandatoryPhone\n    id\n  }\n}\n\nfragment TournamentPlayer_tournamentPlayer on TournamentPlayer {\n  category\n  databaseId\n  hasScores\n  hasPaid\n  id\n  rounds\n  status\n  tournamentId\n  player {\n    category\n    databaseId\n    dateOfBirth\n    firstName\n    gender\n    lastName\n    nationality\n    name\n    userId\n    organisations {\n      name\n      id\n    }\n    id\n  }\n  tournament {\n    hasRoundReservations\n    tournamentRounds {\n      round\n      id\n    }\n    id\n  }\n  ...TournamentPlayerModal_tournamentPlayer\n}\n\nfragment TournamentUserList_query on Query {\n  userPagination(limit: 10, page: 1, sortBy: \"first_name\", sortDirection: \"asc\", tournamentId: $tournamentId) {\n    users {\n      player {\n        databaseId\n        dateOfBirth\n        firstName\n        gender\n        nationality\n        lastName\n        name\n        organisations {\n          name\n          id\n        }\n        id\n      }\n      id\n    }\n    totalCount\n  }\n}\n"
  }
};
})();

node.hash = "f06623272f13d01893acc86b2bea0915";

module.exports = node;
